import React from "react";
import popOverImage from "../../../images/new-images/Invite-popup.png";
import "./popover-inner-content.css";

const Renderpopoverinnercontent = (props) => {
  return (
    <div className="popover-contents">
    <div className="popover-content-wrapper-invitations">
      <h1 className='popover-heading'>Invitations</h1>
      <p className='popover-description'> You can invite people to assess them. </p>
      <img className='pop-img' src={popOverImage}/>
      <p className='popover-command'>Click on an invitation to proceed.</p>
      <button onClick={props.handleCloseInvitationsPopOver}>Got It</button>
    </div>
    </div>
  );
};
export default Renderpopoverinnercontent;



// WEBPACK FOOTER //
// ./src/new/Dashboard/My-Invitations/popover-inner-content.jsx